import React from 'react';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';
import ComponentServiceFeatureOverviewItem from './componentServiceFeatureOverviewItem.js';

/**
 * @typedef {import('../../App.d.ts').ServiceFeaturesOverviewProps} ServiceFeaturesOverviewProps
 */
/**
 * @param {ServiceFeaturesOverviewProps} props
 */
export default (props) => {
  return (
    <div
      data-testid="service-feature-overview"
      className="service-feature-overview-module__container"
    >
      <Container customContentClassName="service-feature-overview-module__header">
        <h6 className="caption">{props.subheadline}</h6>
        <h2 className="headline">{props.headline}</h2>
      </Container>
      <Container
        standout
        customContainerClassName="service-feature-overview-module-container"
        customContentClassName="service-feature-overview-module-container__content"
      >
        {props.keyFeatures.map((feature, index) => (
          <ComponentServiceFeatureOverviewItem
            key={index}
            {...feature}
          />
        ))}
      </Container>
    </div>
  );
};
